module.exports = __webpack_public_path__ + "9127f6078bc56b345dac8613e0256bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/listen/content/assets/sentence.png
// module id = 300
// module chunks = 0